export enum SDK_TYPES {
  DEFAULT = 'DEFAULT',
  FAMILY = 'FAMILY',
  SHARED = 'SHARED',
  PLACE = 'PLACE',
  FILES = 'FILES'
}